import Ajv from "ajv";
const ajv = new Ajv();

import checksubmission from "./schemas/checksubmission.json";
import note from "./schemas/note.json";
import popup from "./schemas/popup.json";
import protocolpart from "./schemas/protocolpart.json";
import protocolstep from "./schemas/protocolstep.json";
import response from "./schemas/response.json";
import singlechoice from "./schemas/singlechoice.json";
import slider from "./schemas/slider.json";
import tabs from "./schemas/tabs.json";
import term from "./schemas/term.json";
import track from "./schemas/track.json";
import scrollableSection from "./schemas/scrollableSection.json";
import scrollableEnd from "./schemas/scrollableEnd.json";
import scrollableStart from "./schemas/scrollableStart.json";
import glossaryTerm from "./schemas/glossaryTerm.json";
import glossarySearch from "./schemas/glossarySearch.json";
import glossaryClose from "./schemas/glossaryClose.json";
import moveMenu from "./schemas/moveMenu.json";
import moveMenuAction from "./schemas/moveMenuAction.json";
import { logError as logDatadogError } from "@labxchange/util-datadog";

// Validate incoming simulation data here
export function validate(data) {
  const schemas = {
    checksubmission: checksubmission,
    note: note,
    popup: popup,
    protocolpart: protocolpart,
    protocolstep: protocolstep,
    response: response,
    singlechoice: singlechoice,
    slider: slider,
    tabs: tabs,
    term: term,
    glossaryTerm: glossaryTerm,
    glossarySearch: glossarySearch,
    glossaryClose: glossaryClose,
    moveMenu: moveMenu,
    moveMenuAction: moveMenuAction,
    track: track,
    scrollableSection: scrollableSection,
    scrollableEnd: scrollableEnd,
    scrollableStart: scrollableStart,
  };

  if (!Object.hasOwn(schemas,data.event_schema)) {
    logDatadogError(`Invalid logging schema: ${data.event_schema}`, data);
    return false;
  }

  // For each event, use the relevant schema based on event_schema
  const schema = schemas[data.event_schema];

  // Data validation: Is the data (checked across the schema) correct?
  const validate = ajv.compile(schema);
  const valid = validate(data);

  // If data is not valid, print/throw errors
  if (!valid) {
    // TODO: Adjust this so that it only shows on local environments
    // alert('invalid event: ' + JSON.stringify(validate.errors))
    // In dev mode we should raise an error so that any issues break the code and are immediately detected.
    if (process.env.NODE_ENV === "development") {
      console.log("invalid event: " + JSON.stringify(validate.errors));
      throw Error(validate.errors);
    } else {
      logDatadogError("Log Event Failed", validate.errors);
    }
  }

  return valid;
}
